import { SVGComponentProps } from "./utils/Types";

const NtripIcon = ({ width = 29, height = 29, className }: SVGComponentProps) => {
    return (
        <svg className={`text-current ${className}`} width={width} height={height} viewBox="0 0 64 64">
            <path fill="currentColor" d="M50,16a11.891,11.891,0,0,0-4.149.74,16.992,16.992,0,0,0-33.59-.614A11.992,11.992,0,0,0,11,39.6V44a2,2,0,0,0,2,2h6v9.172l-3.586-3.586-2.828,2.828,7,7a2,2,0,0,0,2.828,0l7-7-2.828-2.828L23,55.172V46H41v9.172l-3.586-3.586-2.828,2.828,7,7a2,2,0,0,0,2.828,0l7-7-2.828-2.828L45,55.172V46h6a2,2,0,0,0,2-2V39.6A11.992,11.992,0,0,0,50,16ZM49,42H15V30H49Zm4-6.589V28a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v7.411A8,8,0,0,1,13.948,20l.1,0a2,2,0,0,0,2-1.868A12.991,12.991,0,0,1,42,19c0,.249-.019.5-.036.74l-.012.18a2,2,0,0,0,3.209,1.724A7.907,7.907,0,0,1,50,20a8,8,0,0,1,3,15.411Z" />
            <rect fill="currentColor" height="4" width="4" x="19" y="34" /><rect fill="currentColor" height="4" width="18" x="27" y="34" />
        </svg>
    )
}

export default NtripIcon;
